import { render, staticRenderFns } from "./CreativeTable.vue?vue&type=template&id=4b083d1c"
import script from "./CreativeTable.vue?vue&type=script&lang=js"
export * from "./CreativeTable.vue?vue&type=script&lang=js"
import style0 from "./CreativeTable.vue?vue&type=style&index=0&id=4b083d1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports